require('bootstrap/dist/js/bootstrap.min.js');